module.exports = "https://cdn.realtymogul.com/static/media/img_panel_growth.b7119c1d.jpg";